/**
 * Variant Image Filter für Shopify (Atelier Theme)
 * 
 * WIE ES FUNKTIONIERT:
 * - Du vergibst den Produktbildern einen Alt-Text, der dem Variantennamen entspricht
 *   z.B. Alt-Text "Rot" → wird nur bei Variante "Rot" angezeigt
 * - Bilder OHNE passenden Alt-Text werden immer angezeigt (z.B. Lifestyle-Fotos)
 * 
 * EINBINDEN:
 * Shopify Admin → Online Store → Themes → Edit Code
 * → assets/ → "Add a new asset" → Datei hochladen oder neuen .js File anlegen
 * → In theme.liquid vor </body> einfügen:
 *   {{ 'variant-images.js' | asset_url | script_tag }}
 */

(function () {
  'use strict';

  // ─── KONFIGURATION ──────────────────────────────────────────────────────────

  // CSS-Selector für die Galerie-Thumbnails (Atelier Theme)
  // Falls es nicht funktioniert, im Browser Devtools den richtigen Selector finden
  const THUMBNAIL_SELECTORS = [
    '.product__media-list .product__media-item',   // Atelier Standard
    '.product-media-container',
    '[data-media-id]',
    '.thumbnail-list__item',
  ];

  // CSS-Selector für den Haupt-Bild-Container
  const MAIN_IMAGE_SELECTORS = [
    '.product__media-wrapper',
    '.product-single__media',
    '.product__media',
  ];

  // Selector für die Varianten-Buttons/Dropdowns
  const VARIANT_INPUT_SELECTORS = [
    'input[name="id"]',           // verstecktes Input mit Variant-ID
    'select[name="id"]',
    '.variant-input input',
  ];

  // ─── HILFSFUNKTIONEN ────────────────────────────────────────────────────────

  function findElement(selectors) {
    for (const sel of selectors) {
      const el = document.querySelector(sel);
      if (el) return el;
    }
    return null;
  }

  function findAllElements(selectors) {
    for (const sel of selectors) {
      const els = document.querySelectorAll(sel);
      if (els.length > 0) return Array.from(els);
    }
    return [];
  }

  // Gibt den Variantennamen aus dem aktuell ausgewählten Variant-Input zurück
  function getSelectedVariantTitle() {
    // Über Shopify's globales Produkt-Objekt (zuverlässigster Weg)
    if (window.ShopifyAnalytics && window.ShopifyAnalytics.meta) {
      const variantId = getSelectedVariantId();
      const product = window.ShopifyAnalytics.meta.product;
      if (product && product.variants) {
        const variant = product.variants.find(v => v.id == variantId);
        if (variant) return variant.title; // z.B. "Rot / L"
      }
    }
    return null;
  }

  function getSelectedVariantId() {
    for (const sel of VARIANT_INPUT_SELECTORS) {
      const el = document.querySelector(sel);
      if (el && el.value) return el.value;
    }
    return null;
  }

  // Prüft ob ein Bild zu einer Variante gehört (via Alt-Text)
  function imageMatchesVariant(imgAlt, variantTitle) {
    if (!imgAlt || !variantTitle) return true; // kein Alt-Text = immer anzeigen
    const alt = imgAlt.toLowerCase().trim();
    const variant = variantTitle.toLowerCase();

    // Unterstützt einfache Variantennamen ("rot") und zusammengesetzte ("rot / l")
    const variantParts = variant.split('/').map(v => v.trim());
    return variantParts.some(part => alt === part || alt.includes(part));
  }

  // ─── HAUPTFUNKTION ──────────────────────────────────────────────────────────

  function filterGalleryByVariant(variantTitle) {
    const thumbnails = findAllElements(THUMBNAIL_SELECTORS);
    if (thumbnails.length === 0) return;

    let firstVisibleThumb = null;

    thumbnails.forEach(thumb => {
      const img = thumb.querySelector('img');
      const alt = img ? img.getAttribute('alt') : null;
      const matches = imageMatchesVariant(alt, variantTitle);

      if (matches) {
        thumb.style.display = '';
        thumb.removeAttribute('aria-hidden');
        if (!firstVisibleThumb) firstVisibleThumb = thumb;
      } else {
        thumb.style.display = 'none';
        thumb.setAttribute('aria-hidden', 'true');
      }
    });

    // Erstes passendes Bild als Hauptbild aktivieren
    if (firstVisibleThumb) {
      const clickTarget = firstVisibleThumb.querySelector('a, button, [data-media-id]');
      if (clickTarget) clickTarget.click();
    }
  }

  // ─── EVENT LISTENER ─────────────────────────────────────────────────────────

  function onVariantChange() {
    const variantTitle = getSelectedVariantTitle();
    if (variantTitle) {
      filterGalleryByVariant(variantTitle);
    }
  }

  function init() {
    // Auf Shopify's natives Variant-Change-Event hören (funktioniert in den meisten Themes)
    document.addEventListener('variant:change', function (e) {
      const variant = e.detail && e.detail.variant;
      if (variant && variant.title) {
        filterGalleryByVariant(variant.title);
      }
    });

    // Fallback: direkt auf Input-Änderungen hören
    document.addEventListener('change', function (e) {
      for (const sel of VARIANT_INPUT_SELECTORS) {
        if (e.target.matches(sel)) {
          setTimeout(onVariantChange, 100); // kurze Verzögerung für Shopify-Updates
          break;
        }
      }
    });

    // Initialer Aufruf beim Laden der Seite
    setTimeout(onVariantChange, 300);
  }

  // Warten bis DOM bereit ist
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();